<template>
    <b-modal
      v-model="showModal"
      size="md"
      hide-footer
      centered
      header-class="EditModalHeaderVariant"
      header-text-variant="white"
      :no-close-on-backdrop="true"
      :title="title"
    >
        <template v-slot:default>
            <div>
                <!-- ラジオボタン部 -->
                <div class="WorkM_InputGroupArea">
                    <b-form-radio-group id="select_list_view_mode" v-model="radioTarget" size="sm" button-variant="outline-primary" buttons @change="onChange()">
                        <b-radio value="0">最近入力</b-radio>
                        <label class="spacer"></label>
                        <b-radio value="1">キーワード検索</b-radio>
                    </b-form-radio-group>
                </div>
                <!-- 検索部 -->
                <div class="mt-3 WorkM_ConstructionList">
                    <!-- 検索部 -->
                    <div v-if="radioTarget === '1'" class="WorkM_InputGroupArea WorkM_ConstructionKeyword">
                        <div class="WorkM_InputGroup_ItemLabel">キーワード</div>
                        <div class="d-flex">
                            <b-input size="sm" v-model="constructionKeyword"></b-input>
                            <b-button variant="transparent" class="WorkM_Button WorkM_ButtonTempSuccess form-control-sm" size="sm" @click="execSearchConstruction()">検索</b-button>
                        </div>
                    </div>
                    <!-- リスト部 -->
                    <div class="WorkM_InputGroupArea" v-bind:class="{'WorkM_ConstructionTableWithKeyword': radioTarget === '1', 'WorkM_ConstructionTableWithoutKeyword': radioTarget !== '1'}">
                        <div class="WorkM_ConstructionTable">
                            <div v-for="constructionItem in optionConstructionCode" :key="constructionItem.code">
                                <div
                                class="WorkInfoItem SearchWorkInfoItem d-flex mx-1 my-1 align-items-center"
                                @click="selectConstruction(constructionItem.code)"
                                v-bind:class="{'WorkM_ConstructionSelectItems': constructionItem.code === selectConstructionCode, 'WorkM_ConstructionItems': constructionItem.code !== selectConstructionCode}">
                                    <b-col cols="3">
                                        <div>{{ constructionItem.code }}</div>
                                    </b-col>
                                    <b-col cols="9">
                                        <div>{{ constructionItem.name }}</div>
                                    </b-col>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
import config from "../../const/config";
export default {
    props: {
        title: { type: String, default: "工事検索" },
        targetType: { type: Number, default: config.VALUE.DISPLAY_TYPE_WORK },
        message: { type: String, default: "" },
        loginUserId: { type: String, default: "" },
    },
    data: function(){
        return{
            showModal: false,
            radioTarget: "0",
            optionConstructionCode: [], 
            optionConstructionCodeWithKeyword: [],
            optionConstructionCodeWithoutKeyword: [],
            selectConstructionCode: 0,
            constructionKeyword: "",
            // loginUserId: "",
        }
    },
    computed: {},
    mounted: function () {
        // this.loginUserId = this.$store.state.user_id;
        // this.getConstructionCode();
        this.optionConstructionCode = [];
    },
    methods: {
        openModal: function () {
            this.selectConstructionCode = 0;
            // this.constructionKeyword = "";   // NOTE: あえて前回の検索キーワードを残す
            this.radioTarget = "0";
            this.getConstructionCode();
            // this.optionConstructionCodeWithKeyword = [];
            // this.optionConstructionCodeWithoutKeyword = [];
            this.showModal = true;
        },
        handleOk: function () {
            this.showModal = false;
            this.$emit("handleOk");
        },
        // ラジオボタン変更時イベント
        onChange(){
            if(this.radioTarget > 0){
                this.getConstructionCode();
                console.debug("optionConstructionCodeWithKeyword：" + JSON.stringify(this.optionConstructionCodeWithKeyword));
                // this.optionConstructionCode = this.optionConstructionCodeWithKeyword;
            }
            else{
                console.debug("optionConstructionCodeWithoutKeyword：" + JSON.stringify(this.optionConstructionCodeWithoutKeyword));
                this.optionConstructionCode = this.optionConstructionCodeWithoutKeyword;
            }
        },
        // 検索実行イベント
        execSearchConstruction: function(){
            // TODO：確認。キーワードに何も入力されていなかったらどうするか？
            // if(this.constructionKeyword == null || this.constructionKeyword == ""){
            //     this.showAlertError("キーワードを入力してください。", "エラー");
            // }
            // else{
            //     this.getConstructionCodeFromJSON();
            // }
            // this.getConstructionCodeFromJSON();
            this.getConstructionCode();
        },
        // テーブル内選択イベント
        selectConstruction: function(constructionCode){
            if(constructionCode != this.selectConstructionCode){
                this.selectConstructionCode = constructionCode;
            }

            if(this.selectConstructionCode == null || this.selectConstructionCode == "" || this.selectConstructionCode == 0){
                this.showAlertError("工事情報を選択してください。");
            }
            else{
                let selectConstruction = this.optionConstructionCode.filter((construction)=>{
                    return construction.code===this.selectConstructionCode
                });
                let selectConstructionName = selectConstruction[0].name;
                let setConstruction = {
                    constructionCode: this.selectConstructionCode,
                    constructionName: selectConstructionName
                }
                this.$emit("selectConstruction", setConstruction)
                this.selectConstructionCode = null;
                this.showModal = false;
                this.$emit("handleOk");
            }
        },
        getConstructionCode: function(){
            this.getConstructionCodeAPI();
        },
        // API呼び出しメソッド
        getConstructionCodeAPI: function(){
            let paramList = {
                shainCd: this.loginUserId,
                target: this.targetType,
                mode: this.radioTarget,
                keyword: this.constructionKeyword,
            }
            this.getWithParams(config.URL.KOUJI_LIST, paramList)
                .then((response) => {
                    console.debug("response：" + JSON.stringify(response));
                    // レスポンスの結果がfalseならエラーメッセージを表示
                    if(!response.result){
                        this.showAlertError(config.MESSAGE.SERVER_ERROR);
                        return;
                    }
                    // 一覧表に結果をセット
                    this.setConstructionCode(response.container.optionConstructionInfo);
                    // this.radioTargetが0より大きい(モードがキーワード検索)ならキーワード検索結果表にセット
                    if(this.radioTarget > 0){
                        this.optionConstructionCodeWithKeyword = response.container.optionConstructionInfo;
                        console.debug("optionConstructionCodeWithKeyword：" + JSON.stringify(this.optionConstructionCodeWithKeyword));
                    }
                    // this.radioTargetが0以下(モードが最近)なら最新結果表にセット
                    else{
                        this.optionConstructionCodeWithoutKeyword = response.container.optionConstructionInfo;
                        console.debug("optionConstructionCodeWithoutKeyword：" + JSON.stringify(this.optionConstructionCodeWithoutKeyword));
                    }
                })
                .catch((e) => {
                    // Note: エラーメッセージは、共通処理で表示している
                    console.log(e);
                })
                .finally(() => {});
        },
        // 読み込んだJSONを一覧にセット
        setConstructionCode: function(items){
            this.optionConstructionCode = items;
            console.debug("optionConstructionCode：" + JSON.stringify(this.optionConstructionCode));
        }
    }
};
</script>
<style>
.WorkM_InputGroup_ItemLabel {
  font-size: 0.85rem;
  color: rgb(13, 91, 136);
  font-weight: 700;
  margin: 0;
}
.WorkM_InputTimeGroup {
  display: flex;
}
.WorkM_InputTimeGroup_InputItem {
  width: 4rem;
}
.EditModalHeaderVariant {
  background-color: rgb(13, 91, 136);
}
.WorkM_ConstructionList{
    min-height:415px;
}
.WorkM_ConstructionItems{
    background: rgb(248, 248, 248);
    border-radius: 5px;
    height: 2rem;
}
.WorkM_ConstructionSelectItems{
    background: #007bff;
    color: #fff;
    border-radius: 5px;
    height: 2rem;
}
.WorkM_ConstructionKeyword{
    height:81px;
}
.WorkM_ConstructionTable{
    width:100%;
}
.WorkM_ConstructionTableWithKeyword{
    max-height:330px;
    overflow-y: auto;
    width:100%;
}
.WorkM_ConstructionTableWithoutKeyword{
    max-height:410px;
    overflow-y: auto;
    width:100%;
}
.SearchWorkInfoItem {
    line-height: 1rem;
}
</style>